import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store'
Vue.use(Router);

const routes = [{
    path: '*',
    redirect: '/home'
  },
  {
    name: 'home',
    component: () => import('./view/home'),
    meta: {
      title: '青少年心理成长监测'
    }
  },
  {
    name: 'loginInfo',
    component: () => import('./view/home/loginInfo'),
    meta: {
      title: '填写你的信息'
    }
  },
  {
    name: 'evaluation',
    component: () => import('./view/home/evaluation'),
    meta: {
      title: '青少年心理健康测评'
    }
  },
  {
    name: 'report',
    component: () => import('./view/home/report'),
    meta: {
      title: '测评报告'
    }
  },
  
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {

    // https://pc.inpsy.cn  https://xypc.mpt.cn // 心悦成长
    const xyOriginBool = store.state.user.xyOriginBool
    if (!xyOriginBool && location.origin === 'https://pc.inpsy.cn') {
        store.commit('user/SET_XYORIGINBOOL', true)
    }
    // https://mx.gdapsy.com/pc // 粤心妍
    const yxyOriginBool = store.state.user.yxyOriginBool
    if (!yxyOriginBool && location.origin === 'https://mx.gdapsy.com/pc') {
        store.commit('user/SET_YXYORIGINBOOL', true)
    }
    // https://mx.gdapsy.com/pc // 全通
    const qtOriginBool = store.state.user.yxyOriginBool
    if (!qtOriginBool && location.origin === 'https://mptpc.qt430.cn') {
        store.commit('user/SET_QTORIGINBOOL', true)
    }

  let path = to.query.from;
  if(path){
    store.commit('user/SET_FROM',path);
  }

  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};